/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService
 */
import * as References from './TemplateManagementAppService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService#listTemplateInstallsByGlobalId
 */
export const LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_TemplateManagementAppService_listTemplateInstallsByGlobalId';
export const LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY: RegisteredQuery<
  'result',
  References.ListTemplateInstallsByGlobalIdRequestType,
  References.ListTemplateInstallsByGlobalIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['templateGlobalId', 'pageLength', 'offset'],
  fetcher(
    request: References.ListTemplateInstallsByGlobalIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListTemplateInstallsByGlobalIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listTemplateInstallsByGlobalIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
